import './video-scroll.scss';

import { smoothScrollTo } from '../../js/helper';
require('../../images/video-scroll/vignette.png');

class VideoScroll {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-videoscroll',
            mediaAttr: 'media',
            contentAttr: 'content',
            startAttr: 'start',
            endAttr: 'end',
            moreAttr: 'more',
            scrollAttr: 'scroll',
            scrollerAttr: 'scroller',
            waitScreens: 2,
            eventScroller: null
        };

        this.settings = Object.assign({}, defaults, options);

        this.$videoScroll = element;
        this.$videoScrollScroller = this.$videoScroll.querySelector('[' + this.settings.initAttr + '="' + this.settings.scrollerAttr + '"]');
        this.$videoScrollMedia = this.$videoScroll.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');
        this.$$videoScrollContents = this.$videoScroll.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.contentAttr + '"]');
        this.$videoScrollEnd = this.$videoScroll.querySelector('[' + this.settings.initAttr + '="' + this.settings.endAttr + '"]');
        this.$videoScrollPrevious = this.$videoScroll.previousElementSibling;
        this.$videoScrollButton = this.$videoScroll.querySelector('[' + this.settings.initAttr + '="' + this.settings.scrollAttr + '"]');
        this.divider = 1;

        if (window.Modernizr.safari) {
            this.divider = 0.5;
        }

        if (window.Modernizr.win) {
            this.divider = 5;
        }

        if (this.$videoScrollScroller === null) {
            console.error('no element found with [' + this.settings.initAttr + '="' + this.settings.scrollerAttr + '"]');
            return;
        }

        if (this.$videoScrollMedia === null) {
            console.error('no element found with [' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');
            return;
        }

        this.eventScroller = this.settings.eventScroller;
    }

    setScrollEvent (player) {
        let waitScreens = this.settings.waitScreens;

        if (window.Modernizr.win) {
            waitScreens = 10;
        }

        const duration = player.duration + waitScreens;
        const videoHeight = parseInt(duration * window.innerHeight / this.divider);
        const steps = duration / videoHeight;

        if (videoHeight > 0) {
            this.$videoScrollScroller.style.height = videoHeight + 'px';
        }

        const $navigation = this.$videoScroll.querySelector('[' + this.settings.initAttr + '="nav"]');

        const setActiveNav = (id, visible) => {
            const $current = $navigation.querySelector('a[href="#' + id + '"]');
            if (visible === true) {
                $current.classList.add('is--active');
            } else {
                $current.classList.remove('is--active');
            }
        };

        this.eventScroller.customFunctions.push(() => {
            const scrollInfo = this.eventScroller.getScrollInfo();
            const position = scrollInfo.position;

            if (this.$videoScrollPrevious !== null) {
                if (position >= this.$videoScroll.offsetTop + 1) {
                    this.$videoScrollPrevious.classList.add('is--hiding');
                } else {
                    this.$videoScrollPrevious.classList.remove('is--hiding');
                }
            }

            if (position >= this.$videoScroll.offsetTop && position < this.$videoScroll.offsetTop + videoHeight - window.innerHeight) {
                const timeCode = steps * (position - this.$videoScroll.offsetTop);

                player.currentTime = timeCode;

                for (let i = 0; i < this.$$videoScrollContents.length; i++) {
                    const $snippet = this.$$videoScrollContents[i];
                    const snippetStart = $snippet.getAttribute(this.settings.initAttr + '-' + this.settings.startAttr);
                    const snippetEnd = $snippet.getAttribute(this.settings.initAttr + '-' + this.settings.endAttr);

                    if (timeCode >= snippetStart) {
                        $snippet.classList.add('is--in');

                        if (timeCode >= snippetEnd) {
                            setActiveNav($snippet.getAttribute('id'), false);
                            $snippet.classList.add('is--out');
                            this.closeOverlay($snippet);
                        } else {
                            setActiveNav($snippet.getAttribute('id'), true);
                            $snippet.classList.remove('is--out');
                        }
                    } else {
                        setActiveNav($snippet.getAttribute('id'), false);
                        $snippet.classList.remove('is--in');
                        this.closeOverlay($snippet);
                    }
                }

                if (this.$videoScrollEnd !== null) {
                    this.$videoScrollEnd.classList.remove('is--out');
                    if (timeCode >= player.duration) {
                        this.$videoScrollEnd.classList.add('is--in');
                    } else {
                        this.$videoScrollEnd.classList.remove('is--in');
                    }
                }
            } else {
                if (this.$videoScrollEnd !== null) {
                    this.$videoScrollEnd.classList.add('is--out');
                }

                for (let i = 0; i < this.$$videoScrollContents.length; i++) {
                    this.$$videoScrollContents[i].classList.remove('is--in');
                    this.$$videoScrollContents[i].classList.remove('is--out');
                }
            }
        });
    }

    initialize () {
        const breakpoint = window.matchMedia('(min-width:1024px)');

        if (breakpoint.matches === true && this.eventScroller !== null) {
            const $chapterNavigation = document.createElement('nav');
            $chapterNavigation.classList.add('video-scroll__navigation');
            $chapterNavigation.setAttribute(this.settings.initAttr, 'nav');

            const $chapterNavigationInner = document.createElement('div');
            $chapterNavigationInner.classList.add('video-scroll__navigation-inner');

            $chapterNavigation.appendChild($chapterNavigationInner);

            for (let i = 0; i < this.$$videoScrollContents.length; i++) {
                const $chapter = this.$$videoScrollContents[i];
                const chapterId = $chapter.getAttribute('id');
                const $chapterNavItem = document.createElement('a');
                const chapterStart = $chapter.getAttribute(this.settings.initAttr + '-' + this.settings.startAttr);

                $chapterNavItem.classList.add('video-scroll__navitem');
                $chapterNavItem.setAttribute('href', '#' + chapterId);

                $chapterNavigationInner.appendChild($chapterNavItem);

                const $anchor = document.createElement('a');
                $anchor.setAttribute('id', 'anchor_' + chapterId);
                $anchor.classList.add('video-scroll__anchor');

                this.$videoScrollScroller.appendChild($anchor);
                $anchor.style.top = (chapterStart * window.innerHeight / this.divider) + 100 + 'px';

                $chapterNavItem.addEventListener('click', (e) => {
                    const $target = document.querySelector('#anchor_' + chapterId);

                    smoothScrollTo(0, $target.offsetTop + this.$videoScroll.offsetTop, 1500);

                    e.preventDefault();
                });
            }

            this.$videoScrollScroller.appendChild($chapterNavigation);

            this.setEvents();
        }
    }

    setEvents () {
        const checkforVideo = (videoElement) => {
            videoElement.play();
            const b = setInterval(() => {
                if (videoElement.readyState >= 1) {
                    videoElement.pause();

                    this.setScrollEvent(videoElement);

                    clearInterval(b);
                }
            }, 500);
        };

        checkforVideo(this.$videoScrollMedia);
        if (window.hasVideo === true) {
            window.addEventListener('video-intro-ended', () => {
                this.$videoScroll.classList.add('is--ready');
            });
        } else {
            this.$videoScroll.classList.add('is--ready');
        }

        window.addEventListener('video-intro-restart', () => {
            this.$videoScroll.classList.remove('is--ready');
        });

        if (this.$videoScrollButton !== null) {
            this.$videoScrollButton.addEventListener('click', (e) => {
                const $chapter = this.$$videoScrollContents[0];
                const chapterId = $chapter.getAttribute('id');
                const $target = document.querySelector('#anchor_' + chapterId);

                smoothScrollTo(0, $target.offsetTop + this.$videoScroll.offsetTop, 1500);

                e.preventDefault();
            });
        }

        for (let i = 0; i < this.$$videoScrollContents.length; i++) {
            const $currentContent = this.$$videoScrollContents[i];
            const $currentContentLink = $currentContent.querySelector('[' + this.settings.initAttr + '="' + this.settings.moreAttr + '"]');

            if ($currentContentLink) {
                const $closeContentLink = document.createElement('a');
                $closeContentLink.classList.add('video-chapter__close');

                $currentContent.appendChild($closeContentLink);

                $currentContentLink.addEventListener('click', () => {
                    this.showOverlay($currentContent);
                });

                $closeContentLink.addEventListener('click', () => {
                    this.closeOverlay($currentContent);
                });
            }
        }
    }

    closeOverlay ($content) {
        $content.classList.remove('is--overlay');
    }

    showOverlay ($content) {
        for (let i = 0; i < this.$$videoScrollContents.length; i++) {
            const $currentContent = this.$$videoScrollContents[i];

            if ($currentContent !== $content) {
                this.closeOverlay($currentContent);
            }
        }

        $content.classList.add('is--overlay');
    }
}

export { VideoScroll };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$videoScrolls = $context.querySelectorAll('[data-videoscroll="root"]');

        if ($$videoScrolls.length > 0) {
            for (let i = 0; i < $$videoScrolls.length; i++) {
                const $videoScroll = new VideoScroll($$videoScrolls[i], {
                    eventScroller: window.eventScroller
                });
                $videoScroll.initialize();
            }
        }
    }
});
